import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpService } from './http-client';
import { Email } from '../models/email';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Emailer {
  private readonly httpService = inject(HttpService);

  constructor() {
    this.httpService.API_URL = environment.AppConfig.EmailService.URL + '/api/email';
    this.httpService.API_Username = environment.AppConfig.EmailService.Username;
    this.httpService.API_Password = environment.AppConfig.EmailService.Password;
  }

  sendEmail(email: Email): Observable<any> {
    return this.httpService.post<Email, any>('sendemail', email);
  }
}
